// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".countdown[data-v-8075ec92]{gap:.2rem}", "",{"version":3,"sources":["webpack://src/components/shared/AppCountdown.vue"],"names":[],"mappings":"AAAA,4BAA4B,SAAS","sourcesContent":[".countdown[data-v-8075ec92]{gap:.2rem}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
